<hbo-datatable-smart *ngIf="fits$ | async as fits" [typeData]="'fits'" [entities_filter]="entities_filter"
  [types_filter]="types_filter" [prevDynamoKey]="prevDynamoKey" [lastDynamoKey]="lastDynamoKey"
  [pages]="dynamoPaginationService.currentFitPaginationValue" [columns]="columns" [items]="fits"
  (reload)="searchFit($event)" [showDateFilter]="true" [paginationType]="'dynamo'">
  <tbody class="table-group-divider accordion" id="accordionFit">
    <ng-container *ngFor="let fit of fits.data">
      <tr class="accordion-header">
        <th scope="row"><button class="accordion-button collapsed" data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapse-' + fit.code_measure" (click)="loadData(fit)"></button></th>
        <td *ngIf="user.roleId !== 4">{{ setCrossShop(fit.shop_id) }}</td>
        <td *ngIf="user.roleId !== 4">{{ fit.shop_id }}</td>
        <td [class.text-danger]="fit['hard_deleted_at']">{{ fit.code_measure }}</td>
        <td>
          <ng-container *ngIf="fit.internalRef_block || fit['hard_deleted_at']">
            {{ fit.internalRef }}
          </ng-container>
          <div class="input-group w-75" *ngIf="!fit.internalRef_block && !fit['hard_deleted_at']">
            <input type="text" class="form-control" placeholder="Your Reference" [(ngModel)]="fit.internalRef">
            <button *ngIf="user.profileId !== 2" type="button" class="btn btn-outline-secondary"
              (click)="updateFitReference(fit)">{{ 'COMMON.SAVE' |
              translate }}</button>
          </div>
        </td>
        <td>{{ fit.local_date | date:'yyyy/MM/dd HH:mm' }}</td>
        <td *ngIf="user.roleId !== 4">{{ fit.date | date:'yyyy/MM/dd HH:mm' }}</td>
        <td>
          <span class="badge rounded-pill text-bg-secondary" *ngIf="fit.finished">{{ 'COMMON.FINISHED' | translate
            }}</span>
          <span class="badge rounded-pill text-bg-warning" *ngIf="!fit.finished">{{ 'COMMON.PENDING' | translate
            }}</span>
        </td>
      </tr>
      <tr class="row-body">
        <td [attr.colspan]="user.roleId !== 4 ? 8 : 5" class="bg-light p-0">
          <div [id]="'collapse-' + fit.code_measure" class="accordion-collapse collapse" data-bs-parent="#accordionFit">
            <div class="accordion-body">
              <div class="row p-4" *ngIf="fit['hard_deleted_at'] || measures[fit.TagID]?.['hard_deleted_at']">
                <div class="col-12">
                  <div class="alert alert-warning mb-0">
                    {{ 'FIT.HARD_DELETED_MEASURES' | translate:{ tagId: fit.TagID, codeMeasure: fit.code_measure, internalRef: fit.internalRef || '-', deletedAt: fit['hard_deleted_at'] || measures[fit.TagID]?.['hard_deleted_at'] } }}
                  </div>
                </div>
              </div>

              <div class="row p-4" *ngIf="!fit.finished && !(fit['hard_deleted_at'] || measures[fit.TagID]?.['hard_deleted_at'])">
                <div class="col-5 d-grid">
                  <img *ngIf="measures[fit.TagID]! && measures[fit.TagID].img!" [src]="measures[fit.TagID].img!" alt="User Photo" class="w-100 user-photo">
                  <img *ngIf="!measures[fit.TagID]! || !measures[fit.TagID].img!" [src]="'assets/images/no_img_avaliable.jpg'" alt="User Photo" class="w-100 user-photo">
                  <button type="button" class="btn btn-dark mt-3" (click)="goToInvision(fit)">{{ 'FIT.FINISH' |
                    translate }}
                  </button>
                  <button *ngIf="user.profileId !== 2" type="button" class="btn btn-outline-secondary mt-3" data-bs-toggle="modal"
                    [attr.data-bs-target]="'#confirmationModal-' + fit.code_measure">
                    <i class="bi bi-eye-slash"></i>  {{ (measures[fit.TagID]?.deleted_at ? 'MIMESYS.RECOVER_RESULT' : (measures[fit.TagID]?.canHardDelete ? 'FIT.HIDE_RESULT' : 'MIMESYS.DELETE_RESULT')) | translate }}
                  </button>
                  <button *ngIf="measures[fit.TagID]?.canHardDelete" type="button" class="btn btn-outline-danger mt-3" data-bs-toggle="modal"
                    [attr.data-bs-target]="'#confirmationModal-hard-' + fit.code_measure">
                    <i class="bi bi-trash3-fill"></i>  {{ 'COMMON.HARD_DELETE_RESULT' | translate }}
                  </button>
                  <hbo-confirmation-modal
                    *ngIf="measures[fit.TagID]" [id]="fit.code_measure" (confirm)="delete(fit.TagID, measures[fit.TagID]?.deleted_at !== undefined ? true : false)"
                    [message]="measures[fit.TagID]?.deleted_at ? 'COMMON.SURE_TO_CONTINUE_RESTORE' : 'COMMON.SURE_TO_CONTINUE'"
                    [head]="measures[fit.TagID]?.deleted_at ? 'COMMON.WILL_BE_RESTORED' : 'COMMON.WILL_BE_DELETED'"
                    >
                  </hbo-confirmation-modal>
                  <hbo-confirmation-modal
                    *ngIf="measures[fit.TagID] && measures[fit.TagID]?.canHardDelete" [id]="'hard-' + fit.code_measure" (confirm)="hardDelete(fit.TagID)"
                    [displayId]="fit.code_measure"
                    [message]="'COMMON.SURE_TO_CONTINUE_HARD_DELETE'"
                    [head]="'COMMON.WILL_BE_DELETED'"
                    >
                  </hbo-confirmation-modal>
                </div>
                <div class="col-5 offset-2">
                  <div class="input-group">
                    <input type="text" class="form-control" placeholder="Your comment" [value]="fit.comments"
                      [(ngModel)]="fit.comments">
                    <button type="button" class="btn btn-outline-secondary" (click)="updateFitComments(fit)"
                      *ngIf="user.profileId !== 2">{{
                      'COMMON.SAVE' | translate }}</button>
                  </div>
                </div>
              </div>

              <div class="row p-4" *ngIf="fit.finished && measures[fit.TagID] && !(fit['hard_deleted_at'] || measures[fit.TagID]?.['hard_deleted_at'])">
                <div class="col-6">
                  <table class="table table-borderless table-light measures">
                    <thead>
                      <tr>
                        <th>{{ 'FIT.POSITION' | translate }}</th>
                        <th>{{ 'FIT.RIGHT_EYE' | translate }}</th>
                        <th>{{ 'FIT.LEFT_EYE' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ 'FIT.INTERP_DIST' | translate }} (mm)</td>
                        <td>{{ measures[fit.TagID]?.Naso_R }}</td>
                        <td>{{ measures[fit.TagID]?.Naso_L }}</td>
                      </tr>
                      <tr>
                        <td>{{ 'FIT.FITTING_HEIGHT_BOX' | translate }} (mm)</td>
                        <td>{{ measures[fit.TagID]?.HeightBOX_R ?? '-'}}</td>
                        <td>{{ measures[fit.TagID]?.HeightBOX_L ?? '-'}}</td>
                      </tr>
                      <tr *ngIf="measures[fit.TagID]?.HeightFrame_R">
                        <td>{{ 'FIT.FITTING_HEIGHT_RIM' | translate }} (mm)</td>
                        <td>{{ measures[fit.TagID]?.HeightFrame_R ?? '-'}}</td>
                        <td>{{ measures[fit.TagID]?.HeightFrame_L ?? '-'}}</td>
                      </tr>
                      <tr>
                        <td>{{ 'FIT.VBD' | translate }} (mm)</td>
                        <td>{{ measures[fit.TagID]?.BVD_R }}</td>
                        <td>{{ measures[fit.TagID]?.BVD_L }}</td>
                      </tr>
                      <tr>
                        <td>{{ 'FIT.PANTO' | translate }} (º)</td>
                        <td colspan="2">{{ measures[fit.TagID]?.Panto }}</td>
                      </tr>
                      <tr>
                        <td>{{ 'FIT.WRAP' | translate }} (º)</td>
                        <td colspan="2">{{ measures[fit.TagID]?.Tilt }}</td>
                      </tr>
                      <!--<tr>
                        <td>{{ 'FIT.FRAME_CURVE' | translate }} (D)</td>
                        <td colspan="2">?</td>
                      </tr>-->
                      <tr>
                        <td>{{ 'FIT.HBOX' | translate }} (mm)</td>
                        <td colspan="2">{{ measures[fit.TagID]?.HBOX }}</td>
                      </tr>
                      <tr>
                        <td>{{ 'FIT.VBOX' | translate }} (mm)</td>
                        <td colspan="2">{{ measures[fit.TagID]?.VBOX }}</td>
                      </tr>
                      <tr>
                        <td>{{ 'FIT.DBL' | translate }} (mm)</td>
                        <td colspan="2">{{ measures[fit.TagID]?.DBL }}</td>
                      </tr>
                      <tr *ngIf="measures[fit.TagID]?.Inset_R">
                        <td>{{ 'FIT.NEAR' | translate }} (mm) - {{ measures[fit.TagID]?.NearDistance ?? '-'}} cm </td>
                        <td>{{ measures[fit.TagID]?.NearPD_R }}</td>
                        <td>{{ measures[fit.TagID]?.NearPD_L }}</td>
                      </tr>
                      <tr *ngIf="measures[fit.TagID]?.Inset_R">
                        <td>{{ 'FIT.INSERT' | translate }} (mm) - {{ measures[fit.TagID]?.NearDistance ?? '-'}} cm </td>
                        <td>{{ measures[fit.TagID]?.Inset_R }}</td>
                        <td>{{ measures[fit.TagID]?.Inset_L }}</td>
                      </tr>
                      <tr *ngIf="measures[fit.TagID]?.Corridor">
                        <td>{{ 'FIT.CORRIDOR' | translate }} (mm)</td>
                        <td colspan="2">{{ measures[fit.TagID]?.Corridor ?? '-'}}</td>
                      </tr>
                    </tbody>
                  </table>

                  <div class="d-grid d-md-block gap-2">
                    <button type="button" class="btn btn-outline-secondary me-2 mb-2" (click)="generateDataFile(fit)">
                      <i class="bi bi-download"></i> {{ 'FIT.DATA_FILE' | translate }}
                    </button>
                    <button type="button" class="btn btn-outline-secondary me-2 mb-2" (click)="generatePdf(fit)">
                      <i class="bi bi-download"></i> {{ 'FIT.PDF' | translate }}
                    </button>
                    <button *ngIf="user.roleId === 1" type="button" class="btn btn-outline-secondary me-2 mb-2"
                      (click)="getTar(fit)">
                      <i class="bi bi-download"></i> {{ 'FIT.TAR_MEASURE' | translate }}
                    </button>
                    <button *ngIf="user.roleId === 1" type="button" class="btn btn-outline-secondary me-2 mb-2"
                      (click)="goToInvision(fit)">
                      <i class="bi bi-arrow-counterclockwise"></i> {{ 'FIT.REPROCESS_MEASURE' | translate }}
                    </button>
                    <button *ngIf="user.profileId !== 2" type="button" class="btn btn-outline-secondary me-2 mb-2" data-bs-toggle="modal"
                      [attr.data-bs-target]="'#confirmationModal-' + fit.code_measure">
                      <i class="bi bi-eye-slash"></i>  {{ (measures[fit.TagID]?.deleted_at ? 'MIMESYS.RECOVER_RESULT' : (measures[fit.TagID]?.canHardDelete ? 'FIT.HIDE_RESULT' : 'MIMESYS.DELETE_RESULT')) | translate }}
                    </button>
                    <button *ngIf="measures[fit.TagID]?.canHardDelete" type="button" class="btn btn-outline-danger me-2 mb-2" data-bs-toggle="modal"
                      [attr.data-bs-target]="'#confirmationModal-hard-' + fit.code_measure">
                      <i class="bi bi-trash3-fill"></i>  {{ 'COMMON.HARD_DELETE_RESULT' | translate }}
                    </button>
                    <hbo-confirmation-modal
                      *ngIf="measures[fit.TagID]" [id]="fit.code_measure" (confirm)="delete(fit.TagID, measures[fit.TagID]?.deleted_at !== undefined ? true : false)"
                      [message]="measures[fit.TagID]?.deleted_at ? 'COMMON.SURE_TO_CONTINUE_RESTORE' : 'COMMON.SURE_TO_CONTINUE'"
                      [head]="measures[fit.TagID]?.deleted_at ? 'COMMON.WILL_BE_RESTORED' : 'COMMON.WILL_BE_DELETED'"
                      >
                    </hbo-confirmation-modal>
                    <hbo-confirmation-modal
                      *ngIf="measures[fit.TagID] && measures[fit.TagID]?.canHardDelete" [id]="'hard-' + fit.code_measure" (confirm)="hardDelete(fit.TagID)"
                      [displayId]="fit.code_measure"
                      [message]="'COMMON.SURE_TO_CONTINUE_HARD_DELETE'"
                      [head]="'COMMON.WILL_BE_DELETED'"
                      >
                    </hbo-confirmation-modal>
                  </div>
                </div>
                <div class="col-5 offset-1">
                  <div class="input-group mb-4">
                    <input type="text" class="form-control" placeholder="Your comment" [value]="fit.comments"
                      [(ngModel)]="fit.comments">
                    <button *ngIf="user.profileId !== 2" type="button" class="btn btn-outline-secondary"
                      (click)="updateFitComments(fit)">{{
                      'COMMON.SAVE' | translate }}</button>
                  </div>
                  <img *ngIf="measures[fit.TagID]! && measures[fit.TagID].img!" [src]="measures[fit.TagID].img!" alt="User Photo" class="w-100 user-photo">
                  <img *ngIf="!measures[fit.TagID]! || !measures[fit.TagID].img!" [src]="'assets/images/no_img_avaliable.jpg'" alt="User Photo" class="w-100 user-photo">
                  <div *ngIf="measures[fit.TagID].available" class="row mt-2">
                    <div *ngIf="measures[fit.TagID]['depictLogo']" class="col-auto depictImage">
                      <img [src]="measures[fit.TagID]['depictLogo']" alt="360Depict">
                    </div>
                    <div class="col d-flex align-items-center">
                      <button type="button" class="btn btn-dark w-100" (click)="goTo360Depict(fit)">{{ 'FIT.3D' |
                        translate }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </ng-container>
    <tr *ngIf="!fits.data.length">
      <td colspan="7" class="text-center">{{ 'COMMON.NO_RESULTS' | translate }}</td>
    </tr>
  </tbody>
</hbo-datatable-smart>
<hbo-confirmation-modal
  [id]="'hardDeleteNotification'"
  [status]="'warning'"
  [hideConfirm]="true"
  [head]="'COMMON.WARNING'"
  [message]="hardDeleteNotificationError"
  [cancelText]="'COMMON.UNDERSTAND'">
</hbo-confirmation-modal>
<!--<hbo-regular-progress-modal  [footer]="false" [total]="phases" [phasesCompleted]="phasesCompleted" [error]="errorLoading" [head5]="totalEntities"></hbo-regular-progress-modal>-->